import { EmailResponse } from '@paragon/data-connections';
import { attemptAutomaticLogInWithStoredToken } from '@paragon/login-tools';
import { enqueueError, enqueueInfo } from '@paragon/notification-tools';

import { downloadMultiMergePdf } from '../data/jobData';
import { decrementMultiMergePdfsGenerating, incrementMultiMergePdfsGenerating } from '../store/statusesSlice';
import { loadJobs, loadOrganization, loadRegions, loadViews } from './loadActions';
import { AsyncThunkActionVoid } from './thunkActionTypes';

export const loginAndStartApp = (): AsyncThunkActionVoid => async (dispatch) => {
  const user = await dispatch(attemptAutomaticLogInWithStoredToken());
  if (user) {
    await dispatch(startApp());
  }
};

export const startApp = (): AsyncThunkActionVoid => async (dispatch) => {
  await Promise.all([
    dispatch(loadOrganization()),
    dispatch(loadRegions()),
    dispatch(loadJobs()),
    dispatch(loadViews()),
  ]);
};

export const generateMergedPdf =
  (message: {
    readonly generateMultiMergeCoverPdf: boolean;
    readonly multiMergeJobName: string;
    readonly selectedFileIds: readonly number[];
  }): AsyncThunkActionVoid =>
  async (dispatch) => {
    dispatch(incrementMultiMergePdfsGenerating());
    try {
      const file = await downloadMultiMergePdf(
        message.selectedFileIds,
        message.generateMultiMergeCoverPdf,
        message.multiMergeJobName,
      );
      if (file instanceof EmailResponse) {
        dispatch(
          enqueueInfo(
            'Because this request has more than 100 PDFs, an email will be sent to you when the requested download is ready.',
          ),
        );
      } else {
        file.downloadWithName('MergedPdf.pdf');
      }
    } catch (error) {
      console.error(error);

      if ((error as Error).message) {
        dispatch(enqueueError(`Error: ${(error as Error).message}`));
      } else {
        dispatch(enqueueError('Error generating merged PDF'));
      }
    } finally {
      dispatch(decrementMultiMergePdfsGenerating());
    }
  };
